// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // Import Firestore

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBrLwuqrvHg3aAGlqHy3FIemeSIjTn3qJY",
  authDomain: "pavuluri-d0b1c.firebaseapp.com",
  projectId: "pavuluri-d0b1c",
  storageBucket: "pavuluri-d0b1c.firebasestorage.app",
  messagingSenderId: "796115971482",
  appId: "1:796115971482:web:d3b8cbaad6e36047e41e23",
  measurementId: "G-N6873CPQJQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and Firestore Database
const auth = getAuth(app);
const db = getFirestore(app); // Initialize Firestore

// Export auth and db
export { auth, db };  // Ensure db is being exported here
